<app-analytics-table [cols]="cols" [data]="userLoads" [translationScope]="'user-load-table'"> </app-analytics-table>
